import { NO_CACHE, publicGet } from "@/shared/http/public-http";
import type { SearchProductsResponse, SearchSort, SuggestResponse } from "../types/search.dto";

/**
 * Busca — leitura pública ANÔNIMA (ver `public-http.ts`). Chamada do servidor
 * (/busca) e do browser (dropdown do header).
 *
 * ÚNICO read público FORA do Data Cache (`revalidate: NO_CACHE`), e sem tags.
 * Dois motivos: o espaço de `q` é infinito — cada termo viraria uma entrada que
 * nunca seria reusada nem invalidada, poluindo o cache sem ganho — e o usuário
 * espera resultado fresco ao buscar. Ver `RENDER-STRATEGY-TODO.md`.
 */

export interface SearchProductsParams {
    q?: string;
    storeId: number;
    /** true = só produtos com estoque. */
    inStock?: boolean;
    /** Ordenação explícita (vence a inferida do texto pelo motor). Ausente = relevância. */
    sort?: SearchSort;
    page?: number;
    /** Máx. 100 (limite do back). */
    perPage?: number;
}

/** GET /search/products — busca paginada; `q` vazio = navegação (mais vendidos primeiro). */
export async function searchProducts(
    params: SearchProductsParams
): Promise<SearchProductsResponse> {
    return publicGet<SearchProductsResponse>("/search/products", {
        params: { ...params },
        revalidate: NO_CACHE,
    });
}

/** GET /search/suggest — autocomplete (termos + produtos + categorias), payload mínimo. */
export async function getSuggestions(q: string, storeId: number): Promise<SuggestResponse> {
    return publicGet<SuggestResponse>("/search/suggest", {
        params: { q, storeId },
        revalidate: NO_CACHE,
    });
}
